import axios, { AxiosError } from 'axios';
import { config } from '../config/app.config';
import { handleAuthError, logError, isAuthError } from '../utils/apiErrorHandler';

const apiClient = axios.create({
    baseURL: config.apiUrl,
    withCredentials: true, // Important for HTTP-only cookies
    timeout: 60000, // 60 seconds timeout for large data requests
});

/**
 * Response interceptor to handle errors
 * Redirects to login on 400, 401, 403 errors
 */
apiClient.interceptors.response.use(
    // Success response - pass through
    (response) => response,

    // Error response - handle and redirect
    (error: AxiosError) => {
        // Log the error for debugging
        logError(error, `${error.config?.method?.toUpperCase()} ${error.config?.url}`);

        // Allow callers to opt-out of the global auth-redirect by setting
        // a request header `x-skip-auth-redirect`. This is used for non-
        // blocking background checks where we don't want a full-page
        // navigation when the session is expired.
        const skipRedirect = Boolean((error.config as any)?.headers?.['x-skip-auth-redirect']);
        if (isAuthError(error) && typeof window !== 'undefined') {
            window.dispatchEvent(new CustomEvent('webpos:auth-expired', {
                detail: {
                    redirect: !skipRedirect,
                },
            }));
        }
        if (!skipRedirect && isAuthError(error)) {
            handleAuthError(error);
        }

        // Return error to be handled by calling code
        return Promise.reject(error);
    }
);

export default apiClient;
